<p-dialog header={{termsList}} appendTo="body"   [(visible)]="showTerms"
  (onHide)="onCloseDialog(false)" [modal]="true" [draggable]="false"
  [closable]="!isShow" [resizable]="false" [dismissableMask]="false" [style]="{width: '35%','min-width': '500px','min-height': '750px','transform': 'scale(0.9)', 'transform-origin': 'center center'}"
  [contentStyle]="{'overflow':'hidden'}"
  >
  <div class="tab-container">
    <p-tabView>
      <p-tabPanel header={{termsOfUse}}>
        <div class="terms-content" style="max-height: 500px; overflow-y: auto; width: 100%;min-height: 500px">
          {{AnnouncementDate}}:{{updateDt}}
          <div [innerHTML]="laasTermsContent | safeHtml">
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel  header={{cookiePolicy}}>
        <div class="terms-content" style="max-height: 500px; overflow-y: auto; width: 100%;min-height: 500px">
          <div [innerHTML]="cookieTermsContent | safeHtml">
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel  header={{privacyPolicy}}>
        <div class="terms-content" style="max-height: 500px; overflow-y: auto; width: 100%;min-height: 500px">
          <div [innerHTML]="privateTermsContent | safeHtml">
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel  header={{customerNotification}}>
        <div class="terms-content" style="max-height: 500px; overflow-y: auto; width: 100%;min-height: 500px">
          <div [innerHTML]="customerNotificationContent | safeHtml">
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
  <ng-template pTemplate="footer">
    <div class="checkbox-container" *ngIf="!isView && isShow">
      <input id="checkBox" type="checkbox" [(ngModel)]="agreeTerms" (change)="confirmBtnClickChanged($event)">
      <span class="checkbox-label">{{checkTerms1}}</span>
    </div>
    <button pButton *ngIf="!isView && isShow" [label]="confirm" (click)="confirmBtnClick($event)" [disabled]="!agreeTerms" ></button>
    <button pButton *ngIf="!isView && isShow" [label]="disagree" class="p-button-secondary ml-2" (click)="disagreeBtnClick($event)"></button>
  </ng-template>
</p-dialog>
